function ValidationError(data) {
	Error.call(this);
	if (Error.captureStackTrace) {
		Error.captureStackTrace(this, arguments.callee);
	}

	this.name = 'ValidationError';
	this.statusCode = 400;

	this.message = 'Bad Request';

	this.r = data.r;
	this.i = data.i;
	this.n = data.n;
}

ValidationError.prototype = Object.create(Error.prototype);

ValidationError.prototype.toResponse = function () {
	return {
		r: this.r,
		i: this.i,
		n: this.n
	};
};

module.exports = ValidationError;
